<template>
  <div class="insurance-family-container mr-bt-table-bf">
    <div class="col-md-12 m-b-xs no-padd clear">
      <div class="b-light">
        <div class="content-family">
          <div class="col-md-12 m-t m-b">
            <span class="text-primary h4">
              <i class="fa fa-group" />
              กลุ่มประเภท
              <span class="h3">{{ familyInformationData.member }}</span> บุคคล
            </span>
            <span class="font-bold">
              ส่วนลดกลุ่ม
              <span class="h4 text-warning">{{ familyInformationData.discount }} %</span>
            </span>
            <span class="pull-right font-bold">
              <span style='padding-left: 64px'>
                Family Campaign<br><br>
              </span>
              <span class='pb-4 offside-sale-checkbox-position'>
                <OffsideSaleCheck v-model="isOffsideSaleInsuranceFamily"></OffsideSaleCheck>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-family clear">
      <div class="alert alert-danger" role="alert">
        การคีย์ข้อมูลผู้เอาประกันภัย ที่เป็นผู้ชำระเบี้ยประกันให้กับตนเองและสมาชิกในครอบครัว
        ต้องคีย์ข้อมูลผู้ชำระเบี้ยฯ เป็นผู้เอาประกัยลำดับแรก
      </div>

      <div class="insured-card-section">
        <div
          class="insured-card"
          v-for="(data, index) in quotationInformationList"
          :key="data.quotation.quotationId"
        >
          <div class="insured-card-top-section">
            <div class="insured-information">
              <div class="insured-name">
                ชื่อ-สกุล :
                <span v-if="data.insuredPerson.firstname && data.insuredPerson.lastname">
                  {{ data.insuredPerson.title.name }}
                  {{ data.insuredPerson.firstname }}
                  {{ data.insuredPerson.lastname }}
                </span>
                <span v-else>-</span>
              </div>
              <div class="insured-dob-section">
                <span class="insured-age">
                  อายุ :
                  <span v-if="data.insuredPerson.age">{{ data.insuredPerson.age }}</span>
                  <span v-else>-</span>
                </span>
                <span class="insured-dob">
                  ว/ด/ป เกิด :
                  <span v-if="data.insuredPerson.birthDate">
                    {{
                      moment(data.insuredPerson.birthDate)
                        .add(543, 'years')
                        .format('DD/MM/YYYY')
                    }}
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
            <div class="insured-family-relationship">
              <Dropdown
                class="form-control input-sm"
                :class="{ 'bd-red': errors.has(`relations${index + 1}`) }"
                v-model="relationship[`relations${index + 1}`]"
                :selectedValue="relationship[`relations${index + 1}`]"
                :options="familyRelationshipOptions(index)"
                :disabled="isFirstQuotationCompleted"
              />
            </div>
          </div>
          <div class="insured-card-bottom-section">
            <div class="insurance-information-section">
              <div class="insurance-package-information">
                <div class="package-plan-name">
                  <span class="title">แผนประกันภัย : </span>
                  <span class="value" v-if="data.planPackageScheme">
                    {{ _.get(data, 'planPackageScheme.planName', '') }}
                    , ({{ _.get(data, 'planPackageScheme.coverageCode', '') }})
                  </span>
                  <span class="value" v-else>-</span>
                </div>
                <div class="package-deductible" v-if="data.planPackageScheme">
                  <span class="title">Deductible :</span>
                  <span class="value">
                    {{ _.get(data, 'deductible.deduct', '0') | formatNumber }}
                  </span>
                </div>
                <div class="package-family-discount" v-if="data.planPackageScheme">
                  <span class="title">ส่วนลดครอบครัว :</span>
                  <span class="value">{{ _.get(data, 'familyQuotation.discount', 0) }}%</span>
                </div>
              </div>
              <div class="insurance-price-information">
                <div class="gross-amount">
                  <div class="title">เบี้ยสุทธิ :</div>
                  <div class="value" v-if="data.planPackageScheme">
                    {{ _.get(data, 'pricing.grossPremium', 0) | formatNumber }}
                  </div>
                  <div class="value" v-else>-</div>
                  <div class="title">บาท</div>
                </div>
                <div class="deductible-discount">
                  <div class="title">ส่วนลด Deductible :</div>
                  <div class="value" v-if="data.planPackageScheme">
                    {{ _.get(data, 'pricing.deductDiscount', 0) | formatNumber }}
                  </div>
                  <div class="value" v-else>-</div>
                  <div class="title">บาท</div>
                </div>
                <div class="family-discount">
                  <div class="title">ส่วนลดเบี้ยประกันภัย :</div>
                  <div class="value" v-if="data.planPackageScheme">
                    {{ _.get(data, 'pricing.familyDiscount', 0) | formatNumber }}
                  </div>
                  <div class="value" v-else>-</div>
                  <div class="title">บาท</div>
                </div>
                <div class="net-amount">
                  <div class="title">เบี้ยประกันภัยรวมและอากร​ (0.4%) :</div>
                  <div class="value" v-if="data.planPackageScheme">
                    {{ _.get(data, 'pricing.netPremium', 0) | formatNumber }}
                  </div>
                  <div class="value" v-else>-</div>
                  <div class="title">บาท</div>
                </div>
              </div>
            </div>
            <div
              class="insurance-button-section"
              :class="{ 'combine-payment': isCombineAllPayment }"
            >
              <div class="quotation-button-container">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-check text-primary" v-if="isQuotationDocumentCompleted(data)" />
                    <span v-else>1</span>
                  </span>
                  <Button
                    class="form-control"
                    :type="!checkDisabledQuotationButton(index) ? 'primary' : 'info'"
                    :disabled="checkDisabledQuotationButton(index)"
                    @click.native="validateFamilyRelationship(data)"
                  >
                    ใบเสนอราคา
                  </Button>
                </div>
              </div>
              <div class="application-button-container">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i
                      class="fa fa-check text-primary"
                      v-if="isApplicationDocumentCompleted(data)"
                    />
                    <span v-else>2</span>
                  </span>
                  <Button
                    class="form-control"
                    :type="!checkDisabledApplicationButton(index) ? 'primary' : 'info'"
                    :disabled="checkDisabledApplicationButton(index)"
                    @click.native="redirectApplicationPage(data.application.applicationId)"
                  >
                    ใบคำขอที่ยืนยันแล้ว
                  </Button>
                </div>
              </div>
              <div class="payment-button-container" v-if="!isCombineAllPayment">
                <div class="input-group">
                  <span class="input-group-addon">3</span>
                  <Button
                    class="form-control"
                    :type="isEveryApplicationDocumentCompleted ? 'primary' : 'info'"
                    :disabled="checkDisabledPaymentButton(data)"
                    @click.native="redirectPaymentSummaryPage(data.application.applicationId)"
                  >
                    ชำระเงิน
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-section">
        <div class="title-section">
          <div class="campaign-name">Family Campaign</div>
          <div class="family-type">กลุ่มประเภท {{ familyInformationData.member }} บุคคล</div>
          <div class="family-discount">
            <span>ส่วนลดกลุ่ม </span>
            <span class="highlight-percentage">{{ familyInformationData.discount }}%</span>
          </div>
        </div>
        <div class="discount-cases-container">
          <DiscountFirstCase v-if="familyInformationData.member === 2" />
          <DiscountSecondCase
            v-if="familyInformationData.member === 3 && familyInformationData.discount === 5"
          />
          <DiscountThirdCase
            v-if="familyInformationData.member === 3 && familyInformationData.discount === 10"
          />
          <DiscountFourthCase v-if="familyInformationData.member === 4" />
          <DiscountFifthCase v-if="familyInformationData.member === 5" />
          <DiscountSixthCase v-if="familyInformationData.member === 6" />
        </div>
        <div class="price-summary-section">
          <div
            class="price-item"
            v-for="data in quotationInformationList"
            :key="data.quotation.quotationId"
          >
            <div class="insured-name">
              <span v-if="data.insuredPerson.firstname && data.insuredPerson.lastname">
                {{ data.insuredPerson.title.name }}
                {{ data.insuredPerson.firstname }}
                {{ data.insuredPerson.lastname }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="net-amount">
              <div class="title">เบี้ยประกันภัยรวมและอากร (0.4%)</div>
              <div class="value" v-if="data.planPackageScheme">
                {{ _.get(data, 'pricing.netPremium', 0) | formatNumber }}
              </div>
              <div class="value" v-else>-</div>
              <div class="title">บาท</div>
            </div>
          </div>
          <div class="accumulated-price">
            <div class="title">รวม</div>
            <div
              class="value"
              v-if="_.every(quotationInformationList, quotation => quotation.planPackageScheme)"
            >
              {{ familyInformationData.pricingSum | formatNumber }}
            </div>
            <div class="value" v-else>-</div>
            <div class="title">บาท</div>
          </div>
        </div>
        <div class="pay-all-btn-container" v-if="isCombineAllPayment">
          <Button
            :type="isEveryApplicationDocumentCompleted ? 'primary' : 'info'"
            :disabled="checkDisabledPaymentButton()"
            @click.native="$router.push(`/payment-summary/${firstApplicationId}`)"
          >
            ชำระเงินรวม
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {Validator} from 'vee-validate'
import {mapActions, mapGetters} from 'vuex'
import {createHelpers} from 'vuex-map-fields'
import _ from 'lodash'

import '@/styles/border.css'
import '@/styles/spacing.css'
import '@/styles/float.css'
import Button from '@/components/Button'
import Dropdown from '@/components/Dropdown'
import DiscountFirstCase from "@/views/InsuranceFamily/DiscountFirstCase";
import DiscountFifthCase from "@/views/InsuranceFamily/DiscountFifthCase";
import DiscountSixthCase from "@/views/InsuranceFamily/DiscountSixthCase";
import DiscountFourthCase from "@/views/InsuranceFamily/DiscountFourthCase";
import DiscountThirdCase from "@/views/InsuranceFamily/DiscountThirdCase";
import DiscountSecondCase from "@/views/InsuranceFamily/DiscountSecondCase";
import OffsideSaleCheckbox from "@/components/Checkbox/OffsideSaleCheckbox";

const { mapFields: mapFamilyFields } = createHelpers({
  getterType: 'getFamilyFields',
  mutationType: 'updateFamilyFields',
})

export default {
  components: {
    OffsideSaleCheck: OffsideSaleCheckbox,
    Button,
    Dropdown,
    DiscountFirstCase,
    DiscountSecondCase,
    DiscountThirdCase,
    DiscountFourthCase,
    DiscountFifthCase,
    DiscountSixthCase,
  },
  name: 'InsuranceFamily',
  props: ['family_id'],
  data: () => ({
    errors: null,
    isOffsideSaleInsuranceFamily: false,
  }),
  methods: {
    ...mapActions([
      'getFamilyInformation',
      'getFamilyRelationship',
      'updateFamilyRelationship',
      'fetchIsOffsideSaleFamilyQuotationById',
      'updateOffsideSaleFamilyQuotationById'
    ]),
    familyRelationshipOptions(idx) {
      const defaultOptions = {
        value: null,
        description: 'โปรดระบุสถานะ',
      }

      const relationshipList = _.chain(this.relationship)
          .values()
          .map(relationship => (relationship ? parseInt(relationship, 10) : ''))
          .value()

      const isAllowChildOptions =
          _.chain(relationshipList)
              .filter(data => data === 4)
              .size()
              .value() < 2
      const isSelectedChild = relationshipList[idx] === 4

      const familyRelationshipLength = _.size(this.familyRelationship.data)

      if (idx === 0) {
        const secondPersonRelationship = relationshipList[1]

        const familyRelationshipOptions = _.chain(this.familyRelationship.data)
            .filter(data => data.id < 3)
            .filter(data => data.id !== secondPersonRelationship)
            .map(data => ({
              value: data.id,
              description: data.description,
            }))
            .value()

        return [defaultOptions, ...familyRelationshipOptions]
      }

      if (idx === 1) {
        const firstPersonRelationship = relationshipList[0]

        const familyRelationshipOptions = _.chain(this.familyRelationship.data)
            .filter(data => data.id !== firstPersonRelationship)
            .map(data => ({
              value: data.id,
              description: data.description,
            }))
            .value()

        if (!isAllowChildOptions && !isSelectedChild) {
          return [defaultOptions, ..._.filter(familyRelationshipOptions, data => data.value !== 4)]
        }

        return [defaultOptions, ...familyRelationshipOptions]
      }

      const familyRelationshipOptions = _.chain(this.familyRelationship.data)
          .filter(data => data.id >= 3)
          .map(data => ({
            value: data.id,
            description: data.description,
          }))
          .value()

      if (!isAllowChildOptions && !isSelectedChild) {
        return [defaultOptions, ..._.filter(familyRelationshipOptions, data => data.value !== 4)]
      }

      return [defaultOptions, ...familyRelationshipOptions]
    },
    isQuotationDocumentCompleted(data) {
      const documentProcessStatus = _.get(data, 'quotation.documentProcessStatusId', 1)

      return documentProcessStatus === 3
    },
    isApplicationDocumentCompleted(data) {
      const documentProcessStatus = _.get(data, 'application.documentProcessStatusId', 1)

      return documentProcessStatus === 3
    },
    isApplicationPaymentProcessCompleted(data) {
      return _.get(data, 'application.isPaymentProcessCompleted', false)
    },
    checkDisabledQuotationButton(idx) {
      const quotationInformation = this.quotationInformationList[idx - 1]

      if (idx !== 0) {
        return !this.isQuotationDocumentCompleted(quotationInformation)
      }

      return false
    },
    checkDisabledApplicationButton(idx) {
      const quotationInformation = this.quotationInformationList[idx - 1]
      const lastQuotationInfo = _.last(this.quotationInformationList)

      if (idx !== 0) {
        return !this.isApplicationDocumentCompleted(quotationInformation)
      }

      return !this.isQuotationDocumentCompleted(lastQuotationInfo)
    },
    checkDisabledPaymentButton(data) {
      if (this.isCombineAllPayment) {
        return (
            !this.isEveryApplicationDocumentCompleted ||
            this.isEveryApplicationPaymentProcessCompleted
        )
      }

      const paymentId = _.get(data, 'application.paymentId', null)

      if (paymentId === 3 || paymentId === 4) {
        const paymentStatusId = _.get(data, 'application.paymentStatusId', null)
        const isPaidStatus = paymentStatusId === 3

        return !this.isEveryApplicationDocumentCompleted || isPaidStatus
      }

      return (
          !this.isEveryApplicationDocumentCompleted || this.isApplicationPaymentProcessCompleted(data)
      )
    },
    validateFamilyRelationship(data) {
      this.validator.validateAll(this.relationship).then(validationResult => {
        if (validationResult) {
          return (location.href = `/quotation_family/${data.quotation.quotationId}`)
        }

        this.$swal({
          type: 'error',
          title: 'กรุณาเลือกสถานะ',
        })
      })
    },
    redirectApplicationPage(applicationId) {
      return (location.href = `/application_family/${applicationId}`)
    },
    redirectPaymentSummaryPage(applicationId) {
      return (location.href = `/payment-summary/${applicationId}`)
    },
    setRule() {
      this.validator = new Validator(this.validationRules)
      this.$set(this, 'errors', this.validator.errors)
    },
  },
  watch: {
    isOffsideSaleInsuranceFamily: async function (value) {
      const { family_id: familyId } = this

      if (familyId) {
        const payload = {
          familyId,
          isOffsideSale: value,
        }
        await this.updateOffsideSaleFamilyQuotationById(payload)
      }
    },
    'familyInformation.data': {
      handler() {
        this.$swal.close()

        this.setRule()
      },
      deep: true,
    },
    'familyInformation.isError'() {
      this.$swal.close()
    },
    'relationship.relations1': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations1) {
          this.updateFamilyRelationship(1)
        }
      },
      deep: true,
    },
    'relationship.relations2': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations2) {
          this.updateFamilyRelationship(2)
        }
      },
      deep: true,
    },
    'relationship.relations3': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations3) {
          this.updateFamilyRelationship(3)
        }
      },
      deep: true,
    },
    'relationship.relations4': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations4) {
          this.updateFamilyRelationship(4)
        }
      },
      deep: true,
    },
    'relationship.relations5': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations5) {
          this.updateFamilyRelationship(5)
        }
      },
      deep: true,
    },
    'relationship.relations6': {
      handler() {
        if (!this.isFirstQuotationCompleted && this.relationship.relations6) {
          this.updateFamilyRelationship(6)
        }
      },
      deep: true,
    },
    isOffsideSaleFamilyQuotation: function () {
      this.isOffsideSaleInsuranceFamily = this.isOffsideSaleFamilyQuotation
    },
  },
  computed: {
    ...mapGetters([
      'familyInformation',
      'familyRelationship',
      'validationRules',
      'isOffsideSaleFamilyQuotation',
    ]),
    ...mapFamilyFields({
      relationship: 'relationship',
    }),
    familyInformationData() {
      return _.get(this.familyInformation, 'data.familyInfo', {})
    },
    quotationInformationList() {
      return _.get(this.familyInformation, 'data.quotationInfo', [])
    },
    firstApplicationId() {
      return _.get(
          this.quotationInformationList,
          '[0].application.applicationId',
          '',
      )
    },
    isFirstQuotationCompleted() {
      return this.isQuotationDocumentCompleted(this.quotationInformationList[0])
    },
    isEveryApplicationDocumentCompleted() {
      return _.every(this.quotationInformationList, data =>
        this.isApplicationDocumentCompleted(data),
      )
    },
    isCombineAllPayment() {
      return _.get(
          this.quotationInformationList,
          '[0].familyQuotation.isCombinePayment',
          false,
      )
    },
    isEveryApplicationPaymentProcessCompleted() {
      return _.every(this.quotationInformationList, data =>
        _.get(data, 'application.isPaymentProcessCompleted', false),
      )
    },
  },
  mounted() {
    const { family_id: familyId } = this
    this.$swal({
      title: 'กรุณารอสักครู่',
      html: '<h5 class="m-b-md">กำลังโหลดข้อมูล...</h5><div class="loader"></div>',
      showConfirmButton: false,
      allowOutsideClick: false,
    })

    this.getFamilyRelationship()

    if (familyId) {
      this.getFamilyInformation(familyId)
      this.fetchIsOffsideSaleFamilyQuotationById(familyId)
    }
  },
}
</script>

<style lang="scss">
.offside-sale-checkbox-position {
  position:relative;
  right: -1.5rem
}

.insurance-family-container {
  .content-family {
    padding-top: 5px;
    padding-bottom: 30px;
  }

  .insured-card-section {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(470px, 1fr));

    .insured-card {
      background-color: #fff;
      border-radius: 3px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.09);
      font-size: 14px;
      line-height: 18px;
      margin: 0 15px 15px;
      padding: 15px;

      .insured-card-top-section {
        border-bottom: 1px solid #e0e0e0;
        display: grid;
        grid-template-columns: 1fr 150px;
        grid-gap: 8px;
        margin-bottom: 8px;
        padding-bottom: 15px;

        .insured-information {
          color: #333333;

          .insured-name {
            margin-bottom: 8px;
          }

          .insured-dob-section {
            .insured-age {
              margin-right: 8px;
            }
          }
        }
      }

      .insured-card-bottom-section {
        .insurance-information-section {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
          grid-gap: 10px;
          margin-bottom: 20px;

          .insurance-package-information {
            .package-plan-name,
            .package-deductible,
            .package-family-discount {
              margin-bottom: 4px;
            }
          }

          .insurance-price-information {
            .gross-amount,
            .deductible-discount,
            .family-discount,
            .net-amount {
              margin-bottom: 4px;
              text-align: right;

              .title,
              .value {
                display: inline-block;
              }

              .value {
                text-align: center;
                width: 100px;
              }
            }

            .family-discount {
              border-bottom: 0.5px solid #e0e0e0;
              padding-bottom: 4px;
            }
          }
        }

        .insurance-button-section {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 20px;

          &.combine-payment {
            grid-template-columns: repeat(2, 1fr);
          }

          .quotation-button-container,
          .application-button-container,
          .payment-button-container {
            .btn {
              min-width: unset;
            }
          }
        }
      }
    }
  }

  .summary-section {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.09);
    margin: 0 15px 15px;
    padding: 15px;

    .title-section {
      margin-bottom: 12px;

      .campaign-name {
        font-size: 18px;
        line-height: 22px;
      }

      .family-type {
        color: #27ae60;
      }

      .family-discount {
        font-size: 14px;
        line-height: 18px;
      }

      .campaign-name,
      .family-type,
      .family-discount {
        display: inline-block;
        margin-right: 8px;
      }
    }

    .discount-cases-container {
      margin-bottom: 24px;

      .discount-cases-description {
        color: #000;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 8px;
      }

      .possible-cases-container {
        .possible-cases-item {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-gap: 20px;
          padding: 4px;

          &:not(:last-child) {
            border-bottom: 0.5px solid #bdbdbd;
          }

          .person-case {
            color: #333333;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }

    .price-summary-section {
      counter-reset: benefit-counter;

      .price-item {
        display: grid;
        grid-template-columns: 1fr 1.5fr;
        grid-gap: 20px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 8px;

        .insured-name {
          color: #333333;

          &:before {
            content: counter(benefit-counter) '. ';
            counter-increment: benefit-counter;
          }
        }

        .net-amount {
          text-align: right;

          .value {
            text-align: center;
            width: 100px;
          }

          .title,
          .value {
            display: inline-block;
          }
        }
      }

      .accumulated-price {
        font-size: 14px;
        line-height: 18px;
        text-align: right;

        .value {
          text-align: center;
          width: 100px;
        }

        .title,
        .value {
          display: inline-block;
        }
      }
    }

    .pay-all-btn-container {
      margin-top: 24px;
      text-align: center;
    }
  }

  .highlight-percentage {
    color: #ffc333;
  }

  .parent-icon {
    margin-right: 4px;
  }

  .adult-icon {
    color: #3e88b9;
    margin-right: 4px;
  }

  .baby-icon {
    color: #ffc333;
    margin-right: 4px;
  }
}
</style>
